import React from "react";

interface IconProps {
  view: string;
  currentView: string;
  validView: string[];
  width?: number;
  height?: number;
  selectedResidential?: { id?: string } | null;
  reloadResidentials?: boolean;
}

const Icon: React.FC<IconProps> = ({
  view,
  currentView,
  validView,
  selectedResidential,
  reloadResidentials,
}) => {
  const isActive = validView.includes(currentView);
  const color = isActive ? "text-white" : "group-hover:text-white";
  const color2 = isActive
    ? "text-white"
    : reloadResidentials || (selectedResidential && !selectedResidential.id)
    ? "text-gray-400"
    : "group-hover:text-white";

  const renderIcon = () => {
    switch (view) {
      case "telemetry":
        return "cell_tower";
      case "truckYards":
        return "warehouse";
      case "administration":
        return "work";
      case "platformArea":
        return "garage";
      case "community":
        return "groups";
      case "finance":
        return "paid";
      case "security":
        return "security";
      default:
        break;
    }
  };

  return (
    <span
      className={`material-symbols-outlined ${
        reloadResidentials || selectedResidential ? color2 : color
      } transition duration-75`}
      style={{ fontSize: "24px" }}
    >
      {renderIcon()}
    </span>
  );
};

export default Icon;
